import React from 'react'
import { CaseStudyCard } from '@/components/molecules/CaseStudyCard'
import './CaseStudySection.css'

export interface CaseStudy {
  logoUrl?: string
  logoAlt?: string
  companyName: string
  headline: string
  tags: string[]
  images?: string[]
  imageAlts?: string[]
  cardClassName?: string
}

export interface CaseStudySectionProps {
  caseStudy: CaseStudy
  className?: string
}

export const CaseStudySection: React.FC<CaseStudySectionProps> = ({
  caseStudy,
  className = '',
}) => {
  return (
    <section className={`case-study-section ${className}`}>
      <CaseStudyCard
        logoUrl={caseStudy.logoUrl}
        logoAlt={caseStudy.logoAlt}
        companyName={caseStudy.companyName}
        headline={caseStudy.headline}
        tags={caseStudy.tags}
        images={caseStudy.images}
        imageAlts={caseStudy.imageAlts}
        className={caseStudy.cardClassName}
      />
    </section>
  )
}
